import { DomainObject, EadNode } from 'types';
import { findItemById } from 'utils/find';

/**
 * Function that gets nested item from EAD structure.
 *
 * @param id
 * @param eadStructure
 */
export const getItemFromNestedEadTree = (
  id: string,
  eadStructure?: EadNode
) => {
  if (!eadStructure) {
    return undefined;
  }

  const eadNodes = eadStructure.children ?? [];

  const result = findItemById<DomainObject>(eadNodes, id);

  return result;
};
